var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffericon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.7511C0 15.078 14.3269 0.751099 32 0.751099C49.6731 0.751099 64 15.078 64 32.7511C64 50.4242 49.6731 64.7511 32 64.7511C14.3269 64.7511 0 50.4242 0 32.7511Z",
    fill: "#0675F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 19.4178H34.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35.4177V30.0844",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 34.0845C21.6599 31.4924 22.9263 29.1103 24.8924 27.39C26.8585 25.6696 29.3876 24.7306 32 24.7511C33.7254 24.753 35.4246 25.1733 36.9519 25.9761C38.4791 26.779 39.7888 27.9403 40.7686 29.3605C41.7484 30.7807 42.3691 32.4174 42.5774 34.1302C42.7856 35.8429 42.5753 37.5807 41.9645 39.1943C41.3536 40.808 40.3604 42.2493 39.0701 43.3948C37.7797 44.5402 36.2308 45.3556 34.5561 45.7709C32.8815 46.1862 31.131 46.189 29.455 45.7792C27.779 45.3693 26.2274 44.559 24.9334 43.4178L21.3334 40.2178",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39.4178H21.3334V46.0845",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffericon1);
export default __webpack_public_path__ + "static/media/offericon1.4af8e4ecab9bc6bfbf1b58b9c3868c55.svg";
export { ForwardRef as ReactComponent };